import { APP_BASE_HREF } from '@angular/common';
import { enableProdMode, provideAppInitializer, inject } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { provideRouter, withDisabledInitialNavigation } from '@angular/router';
import { appRoutes } from './app/app.routes';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './app/auth/auth-interceptor';
import { ErrorInterceptor } from './app/error-interceptor';
import { AuthGuard } from './app/auth/auth.guard';
import { AuthGuardAdmin } from './app/auth/auth.guard-admin';
import { AuthGuardAdminOrTeamCaptain } from './app/auth/auth.guard-admin-or-team-captain';
import { AuthGuardAdminOrManager } from './app/auth/auth.guard-admin-or-manager';
import { AuthGuardDailySchedule } from './app/auth/auth.guard-daily-schedule';
import { TenantBootstrapService } from './app/tenant/tenant-bootstrap.service';
import { TENANT_RUNTIME_CONFIG } from './app/tenant/tenant-runtime-config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: TENANT_RUNTIME_CONFIG, useValue: environment.tenantRuntime },
    provideRouter(appRoutes, withDisabledInitialNavigation()),
    provideAnimationsAsync('animations'),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthGuard,
    AuthGuardAdmin,
    AuthGuardAdminOrTeamCaptain,
    AuthGuardAdminOrManager,
    AuthGuardDailySchedule,
    provideAppInitializer(() => inject(TenantBootstrapService).init()),
  ]
}).catch(err => console.error(err));
